import React from 'react';

import Admin from 'hive-admin';
import OriginalActionCreate from 'hive-admin/src/components/ActionCreate';

import { useHotkeys } from 'react-hotkeys-hook';

function ActionWrapper({ children, callback }) {
  useHotkeys(
    'ctrl+s, meta+s',
    (event) => {
      event.preventDefault();
      callback();
    },
    {
      enableOnContentEditable: true,
      enableOnFormTags: ['INPUT', 'TEXTAREA', 'SELECT'],
    },
    [callback],
  );
  return children;
}

class ActionCreate extends OriginalActionCreate {
  static config = {
    ...OriginalActionCreate.config,
    title: 'Napravi',
    messageWorking: 'Pravim...',
    messageSuccess: 'Napravljeno!',
    ghost: true,
    renderAction: (props, instance) => (
      <ActionWrapper callback={instance.handleClick}>
        {instance.renderAction(props)}
      </ActionWrapper>
    ),
  }
}

Admin.addToLibrary(
  'ActionCreate',
  config => ActionCreate.create(config),
);
